import { useEffect, useRef, useState } from "react";
import React from "react";
import Skufilter from "./skufilter";
import { getSkucatlogCategory, billerSearch } from "../skucatalog/utils";
import BillDetailsPopup from "../users/userdetails/modals/biller-billpayements-modal";
import Skucatalogpresentational from "./skucatalogpresentational";

const Skucatalogfunctional = () => {
  const request = {
    page: 1,
    size: 10,
    billerName: null,
    nickName: null,
    country: null,
    billerType: null,
    billerId: null,
    sku: null,
    isFilter: true,
    applicationId: 1,
  };
  const [filterForm, setfilterForm] = useState(request);
  const [billerdetails, setBillerdetails] = useState([]);
  const [rechargebeneficiaryExcel, setRechargeBeneficiaryExcel] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [searchBy, setSearchBy] = useState("");
  const [searchByValue, setSearchByValue] = useState("");
  const [dataLoading, setDataLoading] = useState(false);
  const [sizeShow, setSizeShow] = useState();
  const [showPopupModal, setShowPopupModal] = useState(false);
  const buttonRef = useRef("");
  const csvLink = useRef();
  const [type, setType] = useState([]);
  const [value, setValue] = useState([]);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });
  const [filterLength, setFilterLength] = useState({
    typeLength: 0,
    valuelength: 0,
  });
  const [noOfFiltersSelected, setNoOfFiltersSelected] = useState();
  const [categoryValue, setCategoryValue] = useState([]);
  const [itemloading, setItemLoading] = useState(false);
  const [popupData, setPopupData] = useState([]);
  const [filtercategoryValue, setFilterCategoryValue] = useState([]);

  const options = [
    { value: "Country", label: "Country" },

    { value: "BillerName", label: "Biller Name" },
    { value: "BillerType", label: "Biller Type" },
    { value: "BillerID", label: "Biller ID" },
    { value: "Sku", label: "SKU" },
  ];
  const columns = [
    {
      dataField: "country",
      text: "Country",
      sort: true,
      headerStyle: { minWidth: "200px" },
      style: { minWidth: "200px", textAlign: "Left" },
    },
    {
      dataField: "billerName",
      text: "Biller Name",
      sort: false,
      style: { minWidth: "150px", textAlign: "left" },
    },
    {
      dataField: "category",
      text: "Biller type",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "160px", textAlign: "center" },
    },
    {
      dataField: "billerId",
      text: "Biller ID",
      sort: false,
      style: { minWidth: "150px", textAlign: "left" },
    },
    {
      dataField: "sku",
      text: "SKU",
      sort: false,
      style: { minWidth: "150px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },
    {
      dataField: "skuDescription",
      text: "SKU Description",
      sort: false,
      style: { minWidth: "140px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },
    {
      dataField: "daysToPost",
      text: "Days to post",
      sort: false,
      style: { minWidth: "140px", textAlign: "center" },
    },
    {
      dataField: "catalogVersion",
      text: "Catalog Version",
      sort: false,
      style: { minWidth: "150px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },

    {
      dataField: "actions",
      text: "Actions",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "100px", textAlign: "center" },
      formatter: (cell, row) => {
        return (
          <>
            <div
              style={{ color: "black" }}
              onClick={() => {
                if (row && row.id) {
                  let data = [
                    { value: `${row.billerName}`, label: "Biller Name" },
                    { value: `${row.billerId}`, label: "Biller ID" },
                    { value: `${row.sku}`, label: "SKU ID" },
                    { value: `${row.category}`, label: "Biller Type" },
                  ];
                  let ref = row.referenceFields;
                  let refId = ref.split(",");
                  let temp = refId[0] && refId[0].split("|");
                  let temp2 = refId[1] && refId[1].split("|");
                  temp &&
                    data.push({
                      value: `${temp && temp[0]}`,
                      label: "First REF",
                    });
                  temp2 &&
                    data.push({
                      value: `${temp2 && temp2[0]}`,
                      label: "Second REF",
                    });
                  setPopupData(data);
                  setShowPopupModal(true);
                }
              }}
            >
              {" "}
              <i style={{ fontSize: 18 }} className="fas fa-search" />
            </div>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    if (filterForm && filterForm.isFilter) {
      billerSearchList(filterForm);
    }
  }, [filterForm]);
  useEffect(() => {
    billerSearchList(filterForm);
  }, []);
  useEffect(() => {
    setSearchByValue([]);
  }, [categoryValue]);
  const billerSearchList = (request) => {
    request.size = sizeShow || 10;
    setDataLoading(true);
    billerSearch(request)
      .then((res) => {
        setDataLoading(false);
        setBillerdetails(res.data.billers);
        setPagination({
          ...pagination,
          pageSize: sizeShow || 10,
          total: res.data.totalCount,
          current: request.page,
        });
      })
      .catch((err) => {
        setDataLoading(false);
        setBillerdetails([]);
      });
  };
  const CategorySelect = (value, type = "search") => {
    setItemLoading(true);
    getSkucatlogCategory(value)
      .then((res) => {
        setItemLoading(false);
        let response = res.data;

        if (value == "Country") {
          let keys = Object.keys(response);
          let label = Object.values(response);
          let result = keys.map((item, i) => {
            return { value: item, label: label[i], category: value };
          });
          type === "search" && setCategoryValue(result);
          type === "filter" && setFilterCategoryValue(result);
        } else {
          let keys = Object.values(response);
          let result = keys.map((item) => {
            return { value: item, label: item, category: value };
          });

          type === "search" && setCategoryValue(result);
          type === "filter" && setFilterCategoryValue(result);
        }
      })
      .catch((err) => {
        setItemLoading(false);
        setCategoryValue([]);
        setFilterCategoryValue([]);
      });
  };
  const payload = (categoryValue) => {
    let temp = "";
    value.map((item, i) => {
      if (item.category === categoryValue) {
        temp = temp + item.value + (i + 1 < value.length ? "," : "");
      }
    });
    return temp || "";
  };
  const handleFilter = () => {
    let request = {};
    if (type && type.length > 0) {
      let categoryType = type.map((item) => {
        return item.value;
      });
      if (categoryType.includes("Country")) {
        request.Country = payload("Country");
      }
      if (categoryType.includes("BillerName")) {
        request.billerName = payload("BillerName");
      }
      if (categoryType.includes("BillerID")) {
        request.billerId = payload("BillerID");
      }
      if (categoryType.includes("BillerType")) {
        request.billerType = payload("BillerType");
      }
      if (categoryType.includes("Sku")) {
        request.sku = payload("Sku");
      }
    }
    request[searchBy.value] = searchByValue.value;
    request.isFilter = true;
    request.page = 1;

    setfilterForm(request);
  };

  const resetFilter = () => {
    setType();
    setValue();
    setSearchBy("");
    setSearchByValue("");
    setCategoryValue([]);
    setFilterCategoryValue([]);
    setfilterForm({
      ...request,
    });

    setNoOfFiltersSelected(0);
    setFilterLength({ typeLength: 0, valuelength: 0 });
  };

  return (
    <>
      <Skucatalogpresentational
        {...{
          itemloading,
          setSearchBy,
          searchBy,
          CategorySelect,
          handleFilter,
          searchByValue,
          categoryValue,
          setShowFilterModal,
          resetFilter,
          noOfFiltersSelected,
          dataLoading,
          setfilterForm,
          filterForm,
          setSizeShow,
          columns,
          pagination,
          billerdetails,
          setCategoryValue,
          setSearchByValue,
          options,
        }}
      />
      <BillDetailsPopup
        show={showPopupModal}
        close={() => setShowPopupModal(false)}
        popupData={popupData}
        title="Biller Details"
      />

      <Skufilter
        options={options}
        itemloading={itemloading}
        show={showFilterModal}
        searchBy={searchBy}
        type={type}
        setType={setType}
        value={value}
        setFilterCategoryValue={setFilterCategoryValue}
        filtercategoryValue={filtercategoryValue}
        setValue={setValue}
        CategorySelect={CategorySelect}
        onHide={() => {
          setShowFilterModal(false);
        }}
        saveButtonClicked={() => {
          setfilterForm({ ...filterForm, isFilter: false });
          setShowFilterModal(false);
        }}
        setNoOfFiltersSelected={setNoOfFiltersSelected}
        setFilterLength={setFilterLength}
        filterLength={filterLength}
      />
    </>
  );
};

export default Skucatalogfunctional;
